import '.d{display:flex;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.ax{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ay{max-width:77.5rem;}.ssr-plugin'
import '.fx{justify-content:stretch;}.ssr-plugin'
import '.bq{position:sticky;}.ssr-plugin'
import '.br{top:0px;}.ssr-plugin'
import '.bv{z-index:10;}.ssr-plugin'
import '.fy{padding-block:1rem;}.ssr-plugin'
import '.fz{height:3rem;}.ssr-plugin'
import '.bg{justify-content:space-between;}.ssr-plugin'
import '.bi{flex-wrap:wrap;}.ssr-plugin'
import '.g0{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ee{margin-top:2rem;}.ssr-plugin'
import '.g1{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d ad a3 e dj"
      >
        <div className="ax d r a3 e"
        >
          <div className="ay d e fx bq br bv dj"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fy fz d bg r bi"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="g0 d e ad ee g1 ay"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
